import { useMemo } from "react"

import {
  ColorConfigMbaConfig,
  MbaConfiguration,
  MediaTypeMbaConfig,
} from "models/mba"

import { Rable } from "components/Rable"
import { columns } from "./columns"
import { css } from "@emotion/css"
import { useI18n } from "providers/I18n"

const getColorConfig = (config?: ColorConfigMbaConfig) =>
  Object?.keys(config ?? {})?.map((k) => ({ id: k }))

type Props = {
  data?: Array<Partial<MediaTypeMbaConfig>>
  update: (
    variables: MbaConfiguration & { clientConfig?: string },
  ) => Promise<MbaConfiguration> | void
  id?: string
  configScope?: "CAMPAIGN" | "CLIENT_AGENCY"
}

export function MediaTypesSettings(props: Props) {
  const { t } = useI18n()
  const { data = [], update, id, configScope } = props

  const onUpdate = (_: unknown, mtd: MediaTypeMbaConfig) => {
    const updatedIndex = data.findIndex((d) => d.id === mtd.id)
    const updatedData = [
      ...data.slice(0, updatedIndex),
      mtd,
      ...data.slice(updatedIndex + 1),
    ]
    !!id && update({ id, configScope, mediaTypes: updatedData })
  }

  const memoColumns = useMemo(() => columns(data) || [], [data])

  return (
    <div className={styles.container}>
      <h5
        className="BodyBody-1BlackBold"
        style={{ marginBottom: "var(--spacing-xl)" }}
      >
        {t("mba.media-types-settings.title")}
      </h5>
      <div style={{ overflow: "auto" }}>
        <Rable
          data={getColorConfig(data?.[0]?.colorConfig)}
          columns={memoColumns}
          updateRow={onUpdate}
          label="rate.card.loading"
          hasActions={false}
        />
      </div>
    </div>
  )
}

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
  `,
}
